// Travel tips per destination (keyed by slug)
export const travelTips = {
  rajasthan: [
    "Visit Oct–Mar; March–April for festivals like Holi at Pushkar",
    "Pack: silk scarves for desert wind, light layers for evenings",
    "Tipping culture: 10% at heritage hotels, INR 200/day for guides",
    "Currency: USD/EUR widely accepted at palace hotels; INR for local artisans",
    "Photography: cover head at temples; ask before photographing locals",
  ],
  kerala: [
    "Avoid the monsoon (June–Sept) unless Ayurveda is your sole purpose",
    "Pack breathable cottons + insect repellent for backwater cruises",
    "Try toddy (palm wine) but only at certified shacks recommended by your concierge",
    "Houseboat overnight: bring earplugs (frog chorus is legendary)",
    "Plan Ayurveda for at least 7 nights to feel the benefit",
  ],
  "golden-triangle": [
    "Reserve Taj Mahal dawn tickets 60 days in advance — we handle this",
    "Wear closed shoes inside monuments (no leather inside some)",
    "Avoid Friday at the Taj (closed) and high-noon visits in May–June",
    "Negotiate at Old Delhi markets; never at Khan Market or Defence Colony",
    "Carry small INR notes (₹100/₹50) for guides, drivers, washroom attendants",
  ],
  "himalayan-retreats": [
    "Arrive a day early in Delhi to acclimatise before heli-transfers",
    "Layered cashmere is essential — temperature swings 15°C in a day",
    "Mountain weather can ground helis — keep 24h buffer pre-flight",
    "Stay hydrated; altitude saps water faster than you'd think",
    "Bring a portable battery pack; remote lodges have intermittent power",
  ],
  goa: [
    "South Goa for tranquillity, North for energy and dining",
    "Best months: Nov–Mar; Apr–May is hot but resorts are quiet & cheaper",
    "Try local Konkani feni at a Saraswat house, not at beach shacks",
    "Rent a private yacht through us — public charter routes are limited",
    "Heritage walks in Fontainhas are best at sunrise (cool + golden light)",
  ],
  maldives: [
    "Choose South Malé atoll for short transfers, Noonu for seclusion",
    "Reef-safe sunscreen mandatory at most resorts (we provide on arrival)",
    "Plan one 'do-nothing' day every three — the magic is in stillness",
    "Pack a long kaftan for the Maldivian dinner ritual on the sandbank",
    "Visa-on-arrival for almost all nationalities — we still pre-clear paperwork",
  ],
  dubai: [
    "Dec–Feb is perfect; July–Aug is brutal (45°C)",
    "Dress code: modest in mosques, smart-casual at most restaurants",
    "Friday is the holy day — many places open after 1pm",
    "Tip 10–15% even when service charge is included — Dubai standard",
    "Souk gold is cheaper here than almost anywhere — bargain firmly",
  ],
  switzerland: [
    "Pack thermal base layers Dec–Mar; July nights still need a jumper",
    "Swiss Travel Pass is excellent — we arrange first-class for you",
    "Tipping is included in service; round up for excellent service only",
    "Glacier Express must be reserved 60 days ahead — we handle this",
    "Lake Lucerne steamer dinners are the most romantic kept secret",
  ],
  japan: [
    "Avoid Golden Week (late Apr – early May) — every shrine is full",
    "Tattoos visible? Many onsen ryokans still object — ask your concierge",
    "Cash culture: many smaller temples and ryokans are cash-only",
    "Public transit is sacred-quiet — silence your phone on the shinkansen",
    "Bow rather than handshake; never tip — it's considered insulting",
  ],
  europe: [
    "April–June and September are the sweet spots (warm, uncrowded)",
    "Dress one notch above casual everywhere — Europeans notice",
    "Reserve major museums (Uffizi, Vatican, Louvre) 90 days ahead",
    "Tip 5–10% at restaurants if no service charge appears",
    "Train first-class is often the most luxurious way to move",
  ],
  bhutan: [
    "Carry warm layers — even summer evenings drop to 12°C in the mountains",
    "Photography is restricted inside dzongs; we secure permits in advance",
    "Walk slowly the first 48 hours — Thimphu sits at 2,300m",
    "Cash-only economy outside Thimphu; we provide a pre-loaded wallet",
    "A traditional gho or kira is required for dzong entry — ask us to arrange",
  ],
  "sri-lanka": [
    "Right-hand drive country with chaotic roads — always use our chauffeur",
    "Carry mosquito repellent for Yala safaris (dawn/dusk active)",
    "Tip 10% at restaurants, INR 500/day for safari spotters",
    "Cover shoulders at the Temple of the Tooth and other sacred sites",
    "Tap water unsafe — we provide bottled throughout your journey",
  ],
  africa: [
    "Pack neutral, lightweight clothing — bright colours startle wildlife",
    "Wide-brim hat and high-SPF sunscreen are essential",
    "Light aircraft has 15kg soft-bag limit; we provide compliant duffels",
    "Yellow-fever vaccination required for some routes — we advise pre-trip",
    "Tipping is expected: $20/day to guide, $10/day to camp staff (we brief)",
  ],
};
